import { AnyAction, Dispatch } from 'redux';
import { firebaseService } from "../../services/firebaseService";
import { clearLogin, setLoginError, setLoading, setUpdatingLoginRecord } from './loginSlice';
import { openMessageModal } from '../../components/statusModal/messageModalActionCreators';
import { authService } from '../../services/authService';
import { AxiosError } from 'axios';

export const login = (email: string, password: string, callback: () => void) => async (dispatch: Dispatch<any>) => {
    try {
        dispatch(setLoading(true));
        dispatch(setUpdatingLoginRecord(true));
        dispatch(setLoginError(null));
        await firebaseService.auth().signInWithEmailAndPassword(email, password);
        authService.recordUserSession(true)
            .catch((err) => {
                console.log(err);
            })
            .finally(() => {
                dispatch(setUpdatingLoginRecord(false));
                dispatch(clearLogin(null));
                callback();
            });
    } catch (err) {
        dispatch(setUpdatingLoginRecord(false));
        if ((err as AxiosError).code === "auth/wrong-password" || (err as AxiosError).code === "auth/user-not-found") {
            // handled together to prevent malicious user from identifying a valid email
            dispatch(setLoginError("Auth.InvalidEmailOrPassword"));
        } else if ((err as AxiosError).code === "auth/invalid-email") {
            dispatch(setLoginError("Auth.InvalidEmail"));
        } else {
            dispatch(openMessageModal(null, 'error') as unknown as AnyAction);
        }
    } finally {
        dispatch(setLoading(false));
    }
}

export const logout = (callback: () => void) => async (dispatch: Dispatch<any>) => {
    try {
        await firebaseService.auth().signOut();
        window.localStorage.removeItem('organization');
        location.reload(); // eslint-disable-line no-restricted-globals
        callback();
    } catch (err) {
        dispatch(openMessageModal(null, 'error') as unknown as AnyAction);
        console.error(err);
    }
}

export const signInWithGoogle = () => async (dispatch: Dispatch<any>) => {
    let provider = new firebaseService.auth.GoogleAuthProvider();
    try {
        dispatch(setUpdatingLoginRecord(true));
        let result = await firebaseService.auth().signInWithPopup(provider);
        authService.recordUserSession(true)
            .finally(() => {
                dispatch(setUpdatingLoginRecord(false));
                console.log(result.credential);
                window.location.assign('/');
            });
    } catch (err) {
        dispatch(setUpdatingLoginRecord(false));
        dispatch(openMessageModal(null, 'error') as unknown as AnyAction);
        console.log(err);
    }
}

export const signInWithFacebook = () => async (dispatch: Dispatch<any>) => {
    let provider = new firebaseService.auth.FacebookAuthProvider();
    try {
        dispatch(setUpdatingLoginRecord(true));
        let result = await firebaseService.auth().signInWithPopup(provider);
        authService.recordUserSession(true)
            .catch((err) => {
                console.log(err);
            })
            .finally(() => {
                dispatch(setUpdatingLoginRecord(false));
                console.log(result.credential);
                window.location.assign('/');
            });
    } catch (err) {
        dispatch(setUpdatingLoginRecord(false));
        dispatch(openMessageModal(null, 'error') as unknown as AnyAction);
        console.log(err);
    }
}

export const signInWithApple = () => async(dispatch: Dispatch<any>) => {
    let provider = new firebaseService.auth.OAuthProvider('apple.com');
    provider.addScope('email');
    provider.addScope('name');
    try {
        dispatch(setUpdatingLoginRecord(true));
        let result = await firebaseService.auth().signInWithPopup(provider);
        authService.recordUserSession(true)
            .catch((err) => {
                console.log(err);
            })
            .finally(() => {
                dispatch(setUpdatingLoginRecord(false));
                console.log(result.credential);
                window.location.assign('/');
            });
    } catch (err) {
        dispatch(setUpdatingLoginRecord(false));
        dispatch(openMessageModal(null, 'error') as unknown as AnyAction);
        console.log(err);
    }
}